var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.890625 6.44774V11.5146C0.890625 15.3361 0.891638 17.2463 2.0783 18.4339C3.26496 19.6216 5.17619 19.6216 8.99763 19.6216H11.0244C14.8458 19.6216 16.756 19.6206 17.9437 18.4339C19.1314 17.2473 19.1314 15.3361 19.1314 11.5146V6.44774M0.890625 6.44774H19.1314M0.890625 6.44774L1.76719 4.49902C2.44818 2.98706 2.78766 2.23209 3.47676 1.80648C4.16586 1.38086 5.05053 1.38086 6.81887 1.38086H13.2031C14.9715 1.38086 15.8551 1.38086 16.5453 1.80648C17.2343 2.23209 17.5738 2.98706 18.2548 4.49902L19.1314 6.44774M10.011 6.44774V1.38086",
    stroke: "#533F04",
    strokeWidth: 1.52006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46421 12.0214H12.0378C12.5753 12.0214 13.0908 12.2349 13.4709 12.615C13.851 12.9951 14.0645 13.5106 14.0645 14.0481C14.0645 14.5857 13.851 15.1012 13.4709 15.4813C13.0908 15.8614 12.5753 16.0749 12.0378 16.0749H11.0244M7.98427 9.99463L5.95752 12.0214L7.98427 14.0481",
    stroke: "#533F04",
    strokeWidth: 1.52006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestBlack);
export default __webpack_public_path__ + "static/media/RequestBlack.44ecd318e1119a394b294e4733bbf48c.svg";
export { ForwardRef as ReactComponent };